import UntrackedTournamentsTable from './UntrackedTournamentsTable';

export default UntrackedTournamentsTable;
